import classNames from 'classnames';
import Typography from 'components/generics/texts/Typography';
import { HTMLAttributes, ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';
import classes from './index.module.scss';

export type ProfileEditableTableItemValueType = string | ReactNode | undefined;

export interface ProfileEditableTableItemType {
  key: string;
  value: ProfileEditableTableItemValueType;
  keyClassName?: string;
  valueClassName?: string;
  onClickKey?: () => void;
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  data: ProfileEditableTableItemType[];
}

const ProfileEditableTable = ({ data, className }: Props) => {
  return (
    <div className={classNames(classes.container, className)}>
      {data.map(
        ({ key, value, keyClassName, valueClassName, onClickKey }, index) => {
          const valueIsUndefined = value === undefined;
          const valueIsString = typeof value === 'string';
          const ValueComponent = !valueIsString && value;
          return (
            <div
              key={index}
              className={classes.row}
            >
              <Typography
                onClick={onClickKey && onClickKey}
                className={classNames(classes.key, keyClassName)}
              >
                {key}
              </Typography>
              {valueIsUndefined ? (
                <Skeleton
                  width={100}
                  height={15}
                />
              ) : valueIsString ? (
                <Typography
                  className={classNames(classes.value, valueClassName)}
                >
                  {value}
                </Typography>
              ) : (
                ValueComponent
              )}
            </div>
          );
        }
      )}
    </div>
  );
};

export default ProfileEditableTable;
